// Roles are stored as short codes (for example 'TC'). Screens and emails show the full name.
// Say "TC" in conversation; Resi always shows "Transaction Coordinator".
export const ROLE_LABELS = {
  TC: 'Transaction Coordinator',
  limited_agent: 'Limited Agent',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || '';

// Treats the spelled-out name and the short code as the same role, so "Transaction Coordinator" saved on
// an account works exactly like "TC". Use this wherever a role is read from a user record.
const ROLE_ALIASES = {
  'transaction coordinator': 'TC',
  'tc': 'TC',
  'limited agent': 'limited_agent',
  'limited_agent': 'limited_agent',
};

export const normalizeRole = (role) => {
  if (!role) return role;
  return ROLE_ALIASES[String(role).trim().toLowerCase()] || role;
};
